module.exports = __webpack_public_path__ + "static/media/o_marcel_unsolved.c322af59.png";